// extracted by mini-css-extract-plugin
export default {"page_title":"adminSetting_page_title__aGsNB","changePassword":"adminSetting_changePassword__YIbSR"};